import React, { Component } from 'react';
import { Search, Clear } from '@material-ui/icons';
import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import MapboxSearchResults from '../MapboxSearchResults';
import { coordinatesGeocoder } from '../../../utils/geocoder_helpers';

class MapboxSearchBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: '',
      features: [],
      showDropdown: false,
      focused: false
    };
  }

  apiSuccessCallback = response => {
    let { features } = response;

    features = features.map(feature => {
      return {
        latitude: feature.center[1],
        longitude: feature.center[0],
        placeName: feature.place_name
      };
    });

    this.setState({ features, showDropdown: true });
  };

  toggleFocusState = focused => {
    this.setState({ focused });
  };

  handleSelectFeature = idx => {
    const { placeName } = this.state.features[idx];
    this.props.handleFindLocationSelect(this.state.features[idx]);

    this.setState({ text: placeName, showDropdown: false });
  };

  handleApiError = err => {
    this.setState({ showDropdown: false });
  };

  handleApiComplete = () => {};

  hitMapboxApi = () => {
    if (this.state.text.length === 0) {
      this.setState({ features: [], showDropdown: false });
      return;
    }
    // check if text is a coordinate
    let text = coordinatesGeocoder(this.state.text);
    text = encodeURIComponent(text);
    let url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${text}.json?types=address,place,region,poi,district&access_token=${this.props.mapboxAccessToken}`;
    if (this.props.languageRegionCode) {
      url = `${url}&language=${this.props.languageRegionCode.substring(0, 2)}`;
    }

    ServerCommunicationUtil.getApiEndpoint(url, {}, this.apiSuccessCallback, this.handleApiError, this.handleApiComplete);
  };

  handleOnChange = e => {
    e.preventDefault();

    this.setState({ text: e.currentTarget.value }, this.hitMapboxApi);
  };

  onKeyPress = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  clearText = () => {
    this.setState({ text: '', features: [], showDropdown: false });
  };

  renderClearOrSearch() {
    if (this.state.text.length === 0) {
      return <Search className={styles.icon} />;
    }

    return (
      <button className={styles.clearButton} type="button" onClick={this.clearText}>
        <Clear className={styles.icon} />
      </button>
    );
  }

  render() {
    return (
      <div className={`${styles.container} ${this.state.focused ? styles.containerFocused : ''}`}>
        <div className={styles.searchBar}>
          <input
            onFocus={() => this.toggleFocusState(true)}
            onBlur={() => this.toggleFocusState(false)}
            placeholder={StringConstantsMixin.strings.MAP_CREATOR.SEARCH_OR_CLICK_ON_MAP_TO_START}
            data-testid="mapBoxSearchTextField"
            className={styles.searchInput}
            type="search"
            name="Search"
            onChange={this.handleOnChange}
            onKeyPress={this.onKeyPress}
            value={this.state.text}
          />
          {this.renderClearOrSearch()}
        </div>
        {this.state.showDropdown && <MapboxSearchResults features={this.state.features} selectFeature={this.handleSelectFeature} />}
      </div>
    );
  }
}

MapboxSearchBox.defaultProps = {
  mapboxAccessToken: '',
  handleFindLocationSelect: () => {}
};
MapboxSearchBox.propTypes = {
  mapboxAccessToken: PropTypes.string,
  handleFindLocationSelect: PropTypes.func
};

export default MapboxSearchBox;
